import { render, staticRenderFns } from "./TablePurchaseOrderCreate.vue?vue&type=template&id=5bec1c0d&scoped=true&"
import script from "./TablePurchaseOrderCreate.vue?vue&type=script&lang=js&"
export * from "./TablePurchaseOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec1c0d",
  null
  
)

export default component.exports